import React, { useEffect } from "react";
import Navbar from "../components/layout/navbar";
import Footer from "../components/layout/footer";
import Blogdetails from "../components/pages/Blogs/blogdetails";

const Blogdetail = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Navbar />
      <Blogdetails />
      <Footer />
    </>
  );
};

export default Blogdetail;
